import { authLayout } from "../helpers/withAuth";

export const boxOfficeRoutes = {
  path: "box-office",
  ...authLayout("Box Office", [
    {
      path: "/box-office",
      lazy: () =>
        import("../../modules/dashboards/box-office").then((m) => ({
          Component: m.BoxOfficeHomePage,
        })),
    },
    {
      path: "/box-office/grosstimeseries",
      lazy: () =>
        import("../../modules/dashboards/box-office/grosstimeseries").then(
          (m) => ({ Component: m.BoxOfficeGrossTimeseriesPage }),
        ),
    },
    {
      path: "/box-office/ranking",
      lazy: () =>
        import("../../modules/dashboards/box-office/ranking").then((m) => ({
          Component: m.BoxOfficeRankingPage,
        })),
    },
    {
      path: "/box-office/bo-by-studio",
      lazy: () =>
        import("../../modules/dashboards/box-office/bo-by-studio").then(
          (m) => ({ Component: m.BoByStudioPage }),
        ),
    },
  ]),
};
